import { render } from "./OrderDetailView.vue?vue&type=template&id=5178781a&scoped=true"
import script from "./OrderDetailView.vue?vue&type=script&lang=js"
export * from "./OrderDetailView.vue?vue&type=script&lang=js"

import "./OrderDetailView.vue?vue&type=style&index=0&id=5178781a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5178781a"]])

export default __exports__